export const adminTypes = {
    setIsAdmin: '[admin] sets if the logged user is admin or not',
    setBatchMintList: '[admin] sets the list for batch mint',
    setSalesList: '[admin] sets the list for sales',
    setUsersList: '[admin] sets the list for users',
    setMoneyList: '[admin] sets the list for money',
    setInProgressList: '[admin] sets the list for inProgress',
    setNoMintList: '[admin] sets the list for no mint',
    setLastUpdated: '[admin] sets the last updated timestamp'
}